var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.5 214.6H103.4C91.7 214.6 82.1 205.1 82.1 193.3V79.9C82.1 68.2 91.6 58.6 103.4 58.6H153C154.9 58.6 156.7 59.3 158 60.7L207.6 110.3C208.9 111.6 209.7 113.4 209.7 115.3V193.3C209.7 205.1 200.2 214.6 188.5 214.6ZM103.4 72.8C99.5 72.8 96.3 76 96.3 79.9V193.4C96.3 197.3 99.5 200.5 103.4 200.5H188.5C192.4 200.5 195.6 197.3 195.6 193.4V118.3L150.1 72.8H103.4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.6 122.4H153C149.1 122.4 145.9 119.2 145.9 115.3V65.7C145.9 61.8 149.1 58.6 153 58.6C156.9 58.6 160.1 61.8 160.1 65.7V108.2H202.6C206.5 108.2 209.7 111.4 209.7 115.3C209.7 119.2 206.6 122.4 202.6 122.4Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file.4edaaa08.svg";
export { ForwardRef as ReactComponent };